import { Button, ButtonGroup, SvgIcon } from '@mui/material';
import { RiArrowLeftSLine, RiArrowRightSLine } from '@remixicon/react';

export interface DateSelectorProps {
  todayLabel: string;
  onPrev: () => void;
  onToday: () => void;
  onNext: () => void;
}

const DateSelector = ({
  todayLabel,
  onPrev,
  onToday,
  onNext,
}: DateSelectorProps) => {
  return (
    <ButtonGroup size="small">
      <Button className="min-w-0 p-[6px]" onClick={onPrev}>
        <SvgIcon className="h-[10px] w-[10px]" component={RiArrowLeftSLine} />
      </Button>
      <Button className="min-w-0 p-[6px]" onClick={onToday}>
        {todayLabel}
      </Button>
      <Button className="min-w-0 p-[6px]" onClick={onNext}>
        <SvgIcon
          className="h-[10px] w-[10px] min-w-0"
          component={RiArrowRightSLine}
        />
      </Button>
    </ButtonGroup>
  );
};

export default DateSelector;
